import { baseRequest } from '../../_common/core/http_services'

const attributes = res => {
  const attrs = res && res.data && res.data.data && res.data.data.attributes
  if (!attrs || typeof attrs !== 'object') {
    throw new Error('Unexpected response')
  }
  return attrs
}

const apiErrorMessage = (err, fallback) => {
  const message = err && err.response && err.response.data && err.response.data.message
  return typeof message === 'string' && message.trim() ? message : fallback
}

export const verifyTwoFactorCode = async verificationCode => {
  const res = await baseRequest.post('/user/two-factor-auth/verify', {
    data: {
      attributes: { verificationCode },
    },
  })
  return res.data
}

export const sendTwoFactorCodeViaSms = async () => {
  const res = await baseRequest.post('/user/two-factor-auth/code-via-sms')
  return res.data
}

export const fetchTwoFactorStatus = async () => {
  try {
    const res = await baseRequest.get('/user/two-factor-auth/status')
    const attrs = attributes(res)
    return {
      status: Number(attrs.status) === 1 ? 1 : 0,
      secretConfigured: Boolean(attrs.secretConfigured),
      phone: typeof attrs.phone === 'string' ? attrs.phone : '',
      phoneVerified: Boolean(attrs.phoneVerified),
      smsAvailable: Boolean(attrs.smsAvailable),
    }
  } catch (err) {
    throw new Error(apiErrorMessage(err, 'Could not load sign-in protection status'))
  }
}

export const generateTwoFactorSecret = async (password, reset = false) => {
  try {
    const res = await baseRequest.post('/user/two-factor-auth/secret', {
      data: {
        attributes: { password, reset },
      },
    })
    const attrs = attributes(res)
    if (!attrs.qr || !attrs.secret) {
      throw new Error('Could not generate authenticator setup')
    }
    return { qr: attrs.qr, secret: attrs.secret }
  } catch (err) {
    throw new Error(apiErrorMessage(err, 'Could not generate authenticator setup'))
  }
}

export const setTwoFactorStatus = async ({ password, status, verificationCode }) => {
  try {
    await baseRequest.post('/user/two-factor-auth/status', {
      data: {
        attributes: {
          password,
          status,
          ...(verificationCode ? { verificationCode } : {}),
        },
      },
    })
  } catch (err) {
    throw new Error(apiErrorMessage(err, 'Could not update authenticator app'))
  }
}

export const saveAccountPhone = async number => {
  try {
    await baseRequest.post('/user/phone', {
      data: {
        attributes: { number },
      },
    })
  } catch (err) {
    throw new Error(apiErrorMessage(err, 'Could not save phone number'))
  }
}

export const sendPhoneVerificationCode = async () => {
  try {
    const res = await baseRequest.post('/user/phone/verify', {
      data: {
        attributes: {},
      },
    })
    const attrs = (res && res.data && res.data.data && res.data.data.attributes) || {}
    const message =
      typeof res.data.message === 'string' && res.data.message.trim()
        ? res.data.message
        : 'Verification code sent'
    return {
      message,
      ...(typeof attrs.devCode === 'string' && attrs.devCode ? { devCode: attrs.devCode } : {}),
    }
  } catch (err) {
    throw new Error(apiErrorMessage(err, 'Could not send phone verification code'))
  }
}

export const verifyAccountPhone = async (code, password) => {
  try {
    await baseRequest.post('/user/phone/verify', {
      data: {
        attributes: { code, password },
      },
    })
  } catch (err) {
    throw new Error(apiErrorMessage(err, 'Could not verify phone number'))
  }
}

export const clearPhoneVerification = async password => {
  try {
    await baseRequest.post('/user/phone/clear-verification', {
      data: {
        attributes: { password },
      },
    })
  } catch (err) {
    throw new Error(apiErrorMessage(err, 'Could not remove text backup'))
  }
}
